import styled from 'styled-components';

const SplitFormWrapper = styled.div`
    .btn {
        display: block;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        padding: 1rem 2rem;
        text-transform: uppercase;
        font-size: 0.8rem;
        background: #1695A3;
        color: white;
        border: none;
        border-radius: 3px;
        margin: 0.5rem 0;
    }
    .btn-create-campaign {
        margin-top: 86px;
        max-width: 270px;
        width: 100%;
        padding: 0;
        background-color: rgba(60, 211, 207, 1);

        line-height: 38px;
        font-family: 'Montserrat';
        font-size: 15px;
        color: rgba(255, 255, 255, 1);
        text-align: center;
        letter-spacing: 0.01em;
        border-radius: 20px;

        img {
            height: 18px;
            transform: rotate(90deg) translateY(-14px);
            filter: brightness(0) invert(1);
        }
    }

    .visa, .master, .ae, .apple-pay, .android-pay { margin-right: 21px; width: 65px; height: 65px; }
    .master {       }
    .ae {           }
    .apple-pay {    }
    .android-pay {  }
`;


// export default WithDirection(OrderSummaryWrapper);
export default  SplitFormWrapper ;



// WEBPACK FOOTER //
// ./src/containers/OrderReview/formStyle.js